<template>
  <template v-for="(item, i) in srchres" :key="item">
    <div
      v-if="item.visible !== 'N'"
      class="result fade-in"
      :class="!item.total_amount ? 'result-disabled' : ''"
    >
      <!-- Grid version -->
      <div class="result-grid">
        <div class="result__parking-icon">
          <!-- grid image here -->
          <img
            :src="
              get_lang_image(
                cpkdetails.clients[item.cpk_pro],
                'grid_image'
              )
            "
            alt="carpark product image"
          />
        </div>
        <!-- <h3 class="result__headline">{{ getrans(item.product_display_name) }} ( {{ getrans(item.carpark_name) }} )</h3> -->
        <h3 class="result__headline">{{ getrans(item.carpark_name) }}</h3>
        <div class="result__right-row-01">
          <div class="result__distance">
            <div class="result__info-time">
              <span>{{
                getrans(
                  cpkdetails.clients[item.cpk_pro].distance_in_time_1
                )
              }}</span>
            </div>
            <div class="result__info-text">
              <div class="result__info-transfer">
                <img
                  v-if="cpkdetails.clients[item.cpk_pro].transfer_icon"
                  :src="cpkdetails.clients[item.cpk_pro].transfer_icon"
                />
                <img v-else src="@/assets/images/awesome-walking.svg" />
                {{ getrans("To Terminal") }}
              </div>
            </div>
          </div>

          <!-- RDU -->
          <div
            class="result__cost"
            v-if="
              setbrandid == 'RDU' ||
              setbrandid == 'YHM' ||
              setbrandid == 'LAS' ||
              setbrandid == 'OKC' ||
              setbrandid == 'DEN' ||
              setbrandid == 'SAT' ||
              setbrandid == 'PV1'
            "
          >
            <div class="result__info-cost">
              {{ currency }} {{ parseFloat(item.grand_total).toFixed(2) }}
              <span
                class="result__info-cost-total_amount"
                v-if="
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
                "
              >
                {{ currency }}
                {{
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2)
                }}
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                0
              "
            >
              {{ getrans("Save") }}
              {{
                  (
                    ((parseFloat(item.calculations[0].gate_rate_amount) - parseFloat(item.grand_total)) / item.calculations[0].gate_rate_amount) *
                    100
                  ).toFixed(2)
                }}%
            </div>
          </div>

          <!-- HER -->
          <div class="result__cost" v-else-if="setbrandid == 'HER'">
            <div class="result__info-cost">
              {{ currency }}
              {{
                parseFloat(Math.ceil(item.grand_total)).toFixed(2) -
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) >
                0
                  ? parseFloat(item.calculations[0].gate_rate_amount).toFixed(2)
                  : parseFloat(Math.ceil(item.grand_total)).toFixed(2)
              }}
              <span
                class="result__info-cost-total_amount"
                v-if="
                  parseFloat(item.total_discount) > 0 ||
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                    0
                "
              >
                {{ currency }}
                {{
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2)
                }}
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                parseFloat(item.total_discount) > 0 ||
                parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
              "
            >
              {{ getrans("Save") }}
              {{
                (
                  ((parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                    2
                  ) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2)) /
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    )) *
                  100
                ).toFixed(2)
              }}%
            </div>
          </div>

          <!-- default -->
          <div class="result__cost" v-else>
            <div class="result__info-cost">
              {{ currency }}
              {{ parseFloat(Math.ceil(item.grand_total)).toFixed(2) }}
              <span
                class="result__info-cost-total_amount"
                v-if="
                  parseFloat(item.total_discount) > 0 ||
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                    0
                "
              >
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                parseFloat(item.total_discount) > 0 ||
                parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
              "
            ></div>
          </div>
        </div>
        <div class="result__buttons">
          <div class="result__button result__button-secondary">
            <button @click="view_more[i] = !view_more[i]">
              View more <i class="fas fa-chevron-down"></i>
            </button>
          </div>
          <div
            class="result__button"
            v-if="
              setbrandid == 'RDU' ||
              setbrandid == 'YHM' ||
              setbrandid == 'OKC' ||
              setbrandid == 'DEN' ||
              setbrandid == 'SAT' ||
              setbrandid == 'PV1'
            "
          >
            <button
              :disabled="!item.grand_total"
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,
                  parseFloat(item.grand_total).toFixed(2),
                  item.carpark_name,false,item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{ !item.grand_total ? "Unavailable" : "Book" }}
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;Change Selection
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              {{ !item.grand_total ? "Unavailable" : "Book" }}
            </button>
          </div>

          <div class="result__button" v-else-if="setbrandid == 'HER'">
            <button
              :disabled="!item.total_amount"
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,

                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) -
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    ) >
                    0
                    ? parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                        2
                      )
                    : parseFloat(Math.ceil(item.grand_total)).toFixed(2),
                  item.carpark_name,false,item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{
                !item.total_amount ? getrans("Unavailable") : getrans("Book")
              }}
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{ getrans("Cancel") }}
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              {{
                !item.total_amount ? getrans("Unavailable") : getrans("Book")
              }}
            </button>
          </div>

          <div class="result__button" v-else>
            <button
              :disabled="!item.total_amount"
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2),
                  item.carpark_name,false,item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{
                !item.total_amount ? getrans("Unavailable") : getrans("Book")
              }}
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{ getrans("Cancel") }}
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              {{
                !item.total_amount ? getrans("Unavailable") : getrans("Book")
              }}
            </button>
          </div>
        </div>

        <div
          :class="`result__view-more ${
            view_more[i] ? '' : 'result__view-more--hide'
          }`"
        >
          <p class="result__details result__details--paragraph">
            {{
              getrans(cpkdetails.clients[item.cpk_pro].feature_1)
            }}&nbsp;{{
              getrans(cpkdetails.clients[item.cpk_pro].feature_2)
            }}&nbsp;{{
              getrans(cpkdetails.clients[item.cpk_pro].feature_3)
            }}
          </p>
          <ul class="result__details result__details--list">
            <li v-if="cpkdetails.clients[item.cpk_pro].feature_1">
              {{ getrans(cpkdetails.clients[item.cpk_pro].feature_1) }}
            </li>
            <li v-if="cpkdetails.clients[item.cpk_pro].feature_2">
              {{ getrans(cpkdetails.clients[item.cpk_pro].feature_2) }}
            </li>
            <li v-if="cpkdetails.clients[item.cpk_pro].feature_3">
              {{ getrans(cpkdetails.clients[item.cpk_pro].feature_3) }}
            </li>
          </ul>
          <div class="result__buttons result__buttons-secondary">
            <div
              class="result__button result__button-secondary"
              :style="
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'more_info'
                )
                  ? ''
                  : 'display: none;'
              "
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                :href="
                  get_lang_image(
                    cpkdetails.clients[item.cpk_pro],
                    'more_info'
                  )
                "
              >
                <button class="list-more-info-button">
                  <!-- <img
                  class="result__info-image"
                  src="@/assets/images/Info.svg"
                  alt="user image"
                /> -->
                  <InfoIcon />
                  <span class="result__info-desktop">{{
                    getrans("Info")
                  }}</span>
                </button>
              </a>
            </div>
            <div
              class="result__button result__button-secondary"
              style="padding: 0 0.5rem"
            >
              <a
                v-if="
                  isPDF(
                    get_lang_image(
                      cpkdetails.clients[item.cpk_pro],
                      'map_pdf'
                    )
                  )
                "
                target="_blank"
                rel="noopener noreferrer"
                :href="
                  get_lang_image(
                    cpkdetails.clients[item.cpk_pro],
                    'map_pdf'
                  )
                "
              >
                <button class="list-more-info-button">
                  <!-- <img
                    class="result__map-image"
                    src="@/assets/images/Map.svg"
                    alt="user image"
                  /> -->
                  <MapIcon class="map_svg" />
                  <span class="result__map-desktop">{{ getrans("Map") }}</span>
                </button>
              </a>
              <a
                v-else
                target="_blank"
                rel="noopener noreferrer"
                :href="
                  get_lang_image(
                    cpkdetails.clients[item.cpk_pro],
                    'map_pdf'
                  )
                "
                @click.prevent="
                  showModal_map[item.carpark_id] =
                    !showModal_map[item.carpark_id]
                "
              >
                <button
                  style="
                    margin: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.5rem;
                  "
                >
                  <!-- <img
                    class="result__map-image"
                    src="@/assets/images/Map.svg"
                    alt="user image"
                  /> -->
                  <MapIcon />
                  <span class="result__map-desktop">{{ getrans("Map") }}</span>
                </button>
              </a>
            </div>
          </div>
          <div class="result__row-02">
            <div class="result__parking-rating">
              <!-- <div class="result__parking-rating-stars"></div>
              <div class="result__parking-rating-reviews">171 Reviews</div> -->
            </div>
            <div class="result__parking-type">
              {{
                getrans(
                  decodeQuotes(
                    cpkdetails.clients[item.cpk_pro].feature_4
                  )
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <Modal
        :modalWidth="
          isPDF(
            get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')
          )
            ? '100%'
            : 'auto'
        "
        v-if="showModal_map[item.carpark_id]"
        @close="showModal_map[item.carpark_id] = false"
      >
        <template v-slot:header>
          <h4>{{ item.carpark_name }} - {{ getrans("Map") }}</h4>
        </template>
        <template v-slot:body>
          <div
            v-if="
              isPDF(
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'map_pdf'
                )
              )
            "
            class="map-render--pdf"
            v-html="
              renderMapAsIframe(
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'map_pdf'
                )
              )
            "
          ></div>
          <div v-else class="map-render--img">
            <img
              :src="
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'map_pdf'
                )
              "
              :alt="`map image of ${item.carpark_name}`"
            />
          </div>
        </template>
      </Modal>
    </transition>

    <transition name="fade">
      <Modal
        :modalWidth="
          isPDF(
            get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
          )
            ? '100%'
            : 'auto'
        "
        v-if="showModal_info[item.carpark_id]"
        @close="showModal_info[item.carpark_id] = false"
      >
        <template v-slot:header>
          <h4>{{ item.carpark_name }} - {{ getrans("More Information") }}</h4>
        </template>
        <template v-slot:body>
          <div
            v-if="
              isPDF(
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'more_info'
                )
              )
            "
            class="map-render--pdf"
            v-html="
              renderMapAsIframe(
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'more_info'
                )
              )
            "
          ></div>
          <div v-else class="map-render--img">
            <img
              :src="
                get_lang_image(
                  cpkdetails.clients[item.cpk_pro],
                  'more_info'
                )
              "
              :alt="`${getrans('More Info')} ${item.carpark_name}`"
            />
          </div>
        </template>
      </Modal>
    </transition>
  </template>

  <transition name="fade">
    <Modal
      :modalWidth="'auto'"
      v-if="showModal_upsell && single_upsell_data"
      @close="
        showModal_upsell = false;
        gotoPage('/yourdetails.html');
      "
    >
      <template v-slot:header>
        <h4 class="upsell-header">{{ getrans(single_upsell_data.header) }}</h4>
      </template>

      <template v-slot:body>
        <template v-for="item in searchres" :key="item">
          <template
            v-if="
              single_upsell_data.suggesstion_sub_product_id ===
              item.calculations[0].product_id
            "
          >
            <div class="upsell-model">
              <h2 class="upsell-model__closer-from">
                {{
                  single_upsell_data.price_change_text
                    ? getrans(single_upsell_data.price_change_text) +
                      " " +
                      currency +
                      (parseFloat(single_upsell_data.final_amount).toFixed(2) -
                        parseFloat(current_cart.price).toFixed(2))
                    : getrans("Get closer to the terminal for just") +
                      " " +
                      currency +
                      (parseFloat(single_upsell_data.final_amount).toFixed(2) -
                        parseFloat(current_cart.price).toFixed(2))
                }}
              </h2>

              <h4 class="upsell-model__carpark-name">
                {{ getrans(item.carpark_name) }}
              </h4>

              <div class="upsell-model__distance-price">
                <div class="result__info-time">
                  <span>{{
                    getrans(
                      cpkdetails.clients[item.cpk_pro].distance_in_time_1
                    )
                  }}</span>
                  <div class="result__info-transfer">
                    <img
                      v-if="
                        cpkdetails.clients[item.cpk_pro].transfer_icon
                      "
                      :src="
                        cpkdetails.clients[item.cpk_pro].transfer_icon
                      "
                    />
                    <img v-else src="@/assets/images/awesome-walking.svg" />
                    {{ getrans("To Terminal") }}
                  </div>
                </div>
                <div class="upsell-model__cost">
                  <h3>
                    {{ currency }}
                    {{ parseFloat(single_upsell_data.final_amount).toFixed(2) }}
                  </h3>
                </div>
              </div>

              <div class="result__parking-data">
                <!-- <p class="result__details result__details--paragraph">
                  {{ getrans(single_upsell_data.tag_line_1) }}&nbsp;{{
                    getrans(single_upsell_data.tag_line_2)
                  }}&nbsp;{{ getrans(single_upsell_data.tag_line_3) }}
                </p> -->
                <ul class="result__details">
                  <li v-if="single_upsell_data.tag_line_1">
                    {{ getrans(single_upsell_data.tag_line_1) }}
                  </li>
                  <li v-if="single_upsell_data.tag_line_2">
                    {{ getrans(single_upsell_data.tag_line_2) }}
                  </li>
                  <li v-if="single_upsell_data.tag_line_3">
                    {{ getrans(single_upsell_data.tag_line_3) }}
                  </li>
                </ul>
              </div>

              <div class="upsell-model__buttons">
                <button
                  :disabled="upsell_loading_button"
                  @click="
                    upsell_loading_button = 'no';
                    getfttvquvenue();
                  "
                  class="upsell-model__buttons-no"
                >
                  <i
                    v-if="upsell_loading_button === 'no'"
                    class="fas fa-circle-notch fa-spin"
                  ></i
                  >&nbsp;
                  {{ getrans("No Thanks") }}
                </button>
                <button
                  class="upsell-model__buttons-yes"
                  :disabled="upsell_loading_button"
                  @click="
                    upsell_loading_button = 'yes';
                    proceeding_parking[item.carpark_id] = true;
                    reserve(
                      item.carpark_id,
                      single_upsell_data.suggesstion_sub_product_id,
                      parseFloat(single_upsell_data.final_amount).toFixed(2),
                      item.carpark_name,
                      true,item
                    );
                  "
                >
                  <i
                    v-if="upsell_loading_button === 'yes'"
                    class="fas fa-circle-notch fa-spin"
                  ></i
                  >&nbsp;
                  {{ getrans("Yes Please! Upgrade and continue") }}
                </button>
              </div>

              <!-- <pre>
              {{ single_upsell_data }}
              </pre> -->
            </div>
          </template>
        </template>
      </template>
    </Modal>
  </transition>
</template>

<script>
const axios = require("axios");
const genkeys = require("rezauthlib");
import Swal from "sweetalert2";
const { v4: uuidv4 } = require("uuid");

import Modal from "../components/Modal.vue";
import MapIcon from "../components/mapIcon.vue";
import InfoIcon from "../components/infoIcon.vue";
import md5 from "js-md5";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");
export default {
  name: "ResultsMobile",
  components: {
    Modal,
    MapIcon,
    InfoIcon,
  },
  props: {
    searchres: undefined,
    color: undefined,
    carparkdetails: undefined,
    parkingproductdetails: undefined,
    date1_date: undefined,
    date2_date: undefined,
    date1_time: undefined,
    date2_time: undefined,
    lang: undefined,
    translations: undefined,
  },
  computed: {},
  data() {
    return {
      upsell_loading_button: false,
      proceeding_parking: [],
      view_more: [],
      cartdetails: 0,
      chkcart: 0,
      timediffstart: 0,
      showModal_upsell: false,
      single_upsell_data: undefined,
      showModal_map: [],
      visitortypes: [],
      showModal_info: [],
      venue_select: "",
      venue_select_name:"",
      current_cart: "",
      setbrandid: "",
      currency: "",
      cancelling_selection: false,
      cpkdetails:[],
      srchres:[],
      fttvenues:0,
    };
  },
  methods: {
    getfttvquvenue(){
      let dataa = {
        requireTotalCount: true,
        searchOperation: "contains",
        searchValue: null,
        skip: 0,
        take: 25,
        userData: {},
        sort: null,
        group: null,
        totalSummary: [{ summaryType: "count" }],
        query: {},
        ascending: 1,
        byColumn: 1,
        page: 1,
        limit: 25,
        brand_id: this.setbrandid,
        login_user_id:1,
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "vqu/backend/venue/list",
          dataa,
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_VQUVENUE_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_VQUVENUE_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let vs = JSON.parse(response.request.response);
          let fttvenues = vs.data;
          console.log('fttvenues',fttvenues);
          if (typeof fttvenues !== "undefined") {

if(fttvenues.list.length > 0)
{
this.fttvenues = fttvenues.list[0].venue_id;
encryptStorage.setItem('fttvenues', this.fttvenues);
console.log('this.fttvenues',this.fttvenues);
}

}
          this.getvisitortypes();
        });
    },  
    get_lang_image(cpk, prefix) {
      if (!cpk) {
        return "";
      }
      if (cpk[`${prefix}_${this.lang.toLowerCase()}`]) {
        return cpk[`${prefix}_${this.lang.toLowerCase()}`];
      } else if (cpk[`${prefix}_en`]) {
        return cpk[`${prefix}_en`];
      } else {
        return cpk[`${prefix}`];
      }
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    decodeQuotes(str) {
      return str.replace(/&#39;/g, "'");
    },
    isPDF(img) {
      if (/\.pdf$/.test(img)) {
        return true;
      }
      return false;
    },
    renderMapAsIframe(img) {
      return `<iframe src="${img}" width="100%" height="100%"></iframe>`;
    },
    gotoPage(url) {
      window.location.href = url;
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    checkdateequal(dt,tt) {
      let dt1 = dt.replace("/", "-");
      dt1 = dt1.replace("/", "-");
      dt1 = dt1+"T"+tt+":00";
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dtt = [year, month, day].join("-");
      console.info(dtt);
      let dt2 = new Date();
      dt1 = new Date(dt1);
      let t1 = dt1.getTime();
      let t2 = dt2.getTime();
      let t3 = dt1 - dt2;
      t3 = t3 / (1000 * 60 * 60);
      console.info('t1',t1);
      console.info('t2',t2);
      console.info('t3',t3);
      let b = 0;
      if (this.setbrandid === "YHM") {
        if (t3 < 4) {
          b = 0;
        } else {
          b = 1;
        }
      } else {
        if (t3 < 24) {
          b = 0;
        } else {
          b = 1;
        }
      }
      return b;
    },
    formatDateymd_dashed(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },    
    reserve(
      carpark_id,
      product_id,
      price,
      carpark_name,
      upsell_clicked = false,item
    ) {
      let datalayerparams = {};
let datalayeritems = [];
datalayerparams.entry_date = this.formatDateymd_dashed(this.date1_date);
datalayerparams.entry_time = this.date1_time;
datalayerparams.exit_date = this.formatDateymd_dashed(this.date2_date);
datalayerparams.exit_time = this.date2_time;
datalayerparams.venue = this.venue_select_name;
let ecom = {};
let tot = 0;
let items = {};
items.item_id = item.product_id;
items.item_name = item.product_display_name;
items.price = price;
items.quantity = 1;
tot = tot + parseFloat(price);
datalayeritems.push(items);
if(this.setbrandid === "PV1")
{
ecom.currency = "USD";
ecom.send_to="AW-16447517358/Wt3nCJX9vZcZEK7l5KI9";
ecom.item_list_id = "pv1_cpk_list";
ecom.item_list_name  = "PV1 Carpark Search Result List";
}
else
{
ecom.currency = "GBP";
ecom.item_list_id = "nwi_cpk_list";
ecom.item_list_name  = "NWI Carpark Search Result List";
}
ecom.value = tot.toFixed(2);
      
ecom.items = datalayeritems;
datalayerparams.ecommerce = ecom;
encryptStorage.setItem("datalayerparams", datalayerparams);
if (this.setbrandid === "NWI"  || this.setbrandid === "PV1") {
  /* eslint-disable */
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
	event: "add_to_cart",
	datalayerparams,
  });
  /* eslint-enable */
}

      this.resetpromocode();
      encryptStorage.removeItem("session_pay"); 

      if (!upsell_clicked) {
        // Swal.fire({
        //   icon: "info",
        //   text: "Checking offers - Please wait",
        //   showCloseButton: false,
        //   showConfirmButton: false,
        // });
        Swal.fire({
          html: `<div style="padding: 0.5rem 0 0;">
            <h2 style="color:var(--result_title_font_color, #0a3b74)">
              ${this.getrans("Please wait")}
            </h2><i style="font-size: 32px; padding: 1rem; color: var(--result_time_dist_font_color, #0a3b74)" class="fas fa-circle-notch fa-spin"></i>
          </div>`,
          showCloseButton: false,
          showConfirmButton: false,
        });
      }

      setTimeout(function () {
        encryptStorage.removeItem("dis_cpk");
        encryptStorage.removeItem("dis_ftt");
        encryptStorage.removeItem("discount_amount");
        encryptStorage.removeItem("discount_amount_applied");
        encryptStorage.removeItem("discount_coupon_applied");
      }, 3000);

      let orderplaced = encryptStorage.getItem("orderplaced");
      if (typeof orderplaced !== "undefined") {
        if (orderplaced == "Yes") {
          encryptStorage.removeItem("orefwithoutprefix");
        }
      }
      let orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      if (typeof orefwithoutprefix !== "undefined") {
        orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      } else {
        orefwithoutprefix = new Date().getTime();
        encryptStorage.setItem("orefwithoutprefix", orefwithoutprefix);
      }
      //let order_ref = this.setbrandid + "-CPK-" + +new Date().getTime();
      let order_ref = this.setbrandid + "-CPK-" + orefwithoutprefix;
      let data = {
        carpark_id: carpark_id,
        product_id: product_id,
        venue_id: this.venue_select,
        brand_id: this.setbrandid,
        booking_ref_id: order_ref,
        uuid: this.genuuid(),
        valid_from: this.date1_date,
        valid_till: this.date2_date,
        start_time: this.date1_time,
        end_time: this.date2_time,
        slots_to_book: 1,
      };
      let cartdata = {
        carpark_id: carpark_id,
        product_id: product_id,
        product_code:item.carpark_identifier,
        product_name:item.product_display_name,         
        venue_id: this.venue_select,
        brand_id: this.setbrandid,
        booking_ref_id: order_ref,
        orefwithoutprefix: orefwithoutprefix,
        uuid: this.genuuid(),
        valid_from: this.date1_date,
        valid_till: this.date2_date,
        start_time: this.date1_time,
        end_time: this.date2_time,
        slots_to_book: 1,
        price: price,
        carpark_name: carpark_name,
        venue_select_name: this.venue_select_name,
      };
            if(upsell_clicked)
      {
        cartdata.upsell="1";
      }
      let bb = 0;
      if (
        this.setbrandid == "RDU" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "OKC" ||
        this.setbrandid == "PV1"
      ) {
        bb = this.checkdateequal(this.date1_date,this.date1_time);
      } else {
        bb = 1;
      }
      if (bb == 1) {
        encryptStorage.setItem("cart", JSON.stringify(cartdata));
        encryptStorage.setItem("cpkitemincart", JSON.stringify(item));
        if (!upsell_clicked) {
          encryptStorage.setItem("oldcart", JSON.stringify(cartdata));
          encryptStorage.setItem("cpkitemincart", JSON.stringify(item));
        }
        encryptStorage.setItem("tag_totcost", price);
        encryptStorage.setItem("order_ref", order_ref);
		encryptStorage.setItem("order_ref_remove", order_ref);

        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_RESERVE_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_RESERVE_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
              "parking/frontend/carpark/slots/reserve",
            data,
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            //let datasent = JSON.parse(response.request.response);
            this.proceeding_parking[carpark_id] = false;
            if (!upsell_clicked) {
              this.upsellcheck(cartdata);
            } else {
              this.getfttvquvenue();
            }
          });
      } else {
        let resevtaion_err_msg =
          "Reservations within 24 hours of arrival, are unavailable online.";
        if (this.setbrandid == "YHM") {
          resevtaion_err_msg =
            "Reservations cannot be booked less than 4 hours in advance of arrival at the Airport.";
        }
        Swal.fire(
          this.getrans("Error!"),
          this.getrans(resevtaion_err_msg),
          "error"
        );
        this.proceeding_parking[carpark_id] = false;
      }
    },
    upsellcheck(cartdata) {
      let dsa_date_string = "";
      if (
        this.setbrandid == "RDU" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "OKC" ||
        this.setbrandid == "PV1"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "US/Eastern",
        });
      }
      if (this.setbrandid == "HER") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Nicosia",
        });
      }
      if (this.setbrandid == "NWI" || this.setbrandid == "NOC" || this.setbrandid == "LDY") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "AIR") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      dsa_date_string = dsa_date_string.split(",");
      let datepart_str = dsa_date_string[0].split("/");
      let datenow =
        datepart_str[2] +
        "-" +
        datepart_str[1] +
        "-" +
        datepart_str[0] +
        " " +
        dsa_date_string[1];
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_USLCHK_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_USLCHK_SECRETKEY
      );
      let resul = [];
      console.log("this.searchres", this.searchres);
      console.log("this.searchres.length", this.searchres.length);
      Object.entries(this.searchres).forEach((entry) => {
        const [key, value] = entry;
        console.log("key", key);
        let p = 0;
        if(this.setbrandid!='HER')
        {
        p = value.grand_total;
        }
        else
        {
        p = parseFloat(Math.ceil(value.grand_total)).toFixed(2) - parseFloat(value.calculations[0].gate_rate_amount).toFixed(2) >0 ? parseFloat(value.calculations[0].gate_rate_amount).toFixed(2) : parseFloat(Math.ceil(value.grand_total)).toFixed(2)
        }        
        let pid = value.calculations[0].product_id;
        let a = {};
        a.sub_product_id = pid;
        a.amount = p;
        resul.push(a);
      });
      let data = {
        brand_id: this.setbrandid,
        product_id: "CPK",
        selected_sub_product_id: cartdata.product_id,
        selected_sub_product_amount: parseFloat(cartdata.price).toFixed(2),
        booking_date_time: datenow,
        entry_date: cartdata.valid_from,
        exit_date: cartdata.valid_till,
        start_time: cartdata.start_time,
        exit_time: cartdata.end_time,
        sub_products: resul,
      };
      let datacsl = {
        brand_id: this.setbrandid,
        product_id: "CPK",
        venue_id: this.venue_select,
        venue_select_name: this.venue_select_name,
        selected_sub_product_id: cartdata.product_id,
        selected_sub_product_amount: parseFloat(cartdata.price).toFixed(2),
        booking_date_time: datenow,
        entry_date: cartdata.valid_from,
        exit_date:cartdata.valid_till,
        start_time: cartdata.start_time,
        exit_time: cartdata.end_time,
      };
      encryptStorage.setItem("datacsl", datacsl);
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "upsell/frontend/upsell_availability/view",
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          Swal.close();
          let datasent = JSON.parse(response.request.response);
          let user_exists = datasent.user_exists;
          if (user_exists == "Y") {
            encryptStorage.setItem("upsell_shown", "Yes");
            encryptStorage.setItem("upsell_data", datasent);
            encryptStorage.setItem("curr_search_results", this.searchres);
            if (datasent && datasent.data && datasent.data.length === 1) {
              this.showModal_upsell = true;
              this.current_cart = encryptStorage.getItem("cart");
              this.single_upsell_data = datasent.data[0];
            } else if (datasent && datasent.data && datasent.data.length > 1) {
              this.gotoPage("/upsell.html");
            }
          } else {
            encryptStorage.setItem("upsell_shown", "No");
            this.getfttvquvenue();
          }
        });
    },
    getvisitortypes() {
      if (this.setbrandid == "RDU" || this.setbrandid == "YHM" ) {
        this.gotoPage("/yourdetails.html");
      }
      let dataa = {
        requireTotalCount: true,
        searchOperation: "contains",
        searchValue: null,
        skip: 0,
        take: 25,
        userData: {},
        sort: null,
        group: null,
        totalSummary: [{ summaryType: "count" }],
        query: {},
        ascending: 1,
        byColumn: 1,
        page: 1,
        limit: 25,
        brand_id: this.setbrandid,
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "lounge/backend/visitor_type/list",
          dataa,
          {
            headers: {
              secret_id: "ffda61dc9d474d6575d5bc26915aea64",
              secret_key:
                "e299ed60ce833168490712a6cd9c7c1a0c20eec766fced527520118f586cd156",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //console.log(response);
          let vs = JSON.parse(response.request.response);
          this.visitortypes = vs.data;
          this.crosssellcheck();
        });
    },
    crosssellcheck() {
      // if(this.setbrandid=='NWI')
      // {
      //   this.gotoPage("/yourdetails.html");
      // }
      // else
      // {      
      let vis = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      //let adult_pax = 1;
      //let child_pax = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.visitor_type_name == "Child" && visitem.status=='A') {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Adult" && visitem.status=='A') {
          avis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Infant" && visitem.status=='A') {
          ivis = visitem.visitor_type_id;
        }
      }
      if (parseInt(avis) > 0) {
        let it = {};
        it.visitor_type_id = avis;
        it.count = 1;
        vis.push(it);
      }
      if (parseInt(cvis) > 0) {
        let ita = {};
        ita.visitor_type_id = cvis;
        ita.count = 1;
        vis.push(ita);
      }
      if (parseInt(ivis) > 0) {
        let iti = {};
        iti.visitor_type_id = ivis;
        iti.count = 1;
        vis.push(iti);
      }

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETKEY
      );
      let datacsl = encryptStorage.getItem("datacsl");
      if (vis.length > 0) {
        datacsl.lounge = { visitors: vis };
      }
      if (parseInt(this.fttvenues) > 0) {
      let fasttrack_arr = [];
      let outbound_ftt = {guid: this.genuuid(), entry_date: datacsl.entry_date, start_time:datacsl.start_time , unit_data: {"ADL": 1},lane_type:"outbound", venue_id: this.fttvenues};
      let inbound_ftt = {guid: this.genuuid(), entry_date: datacsl.exit_date, start_time:datacsl.exit_time , unit_data: {"ADL": 1},lane_type:"inbound", venue_id: this.fttvenues};
      fasttrack_arr.push(outbound_ftt);
      fasttrack_arr.push(inbound_ftt);
      datacsl.fasttrack = fasttrack_arr;
      }
      encryptStorage.setItem("datacsl", datacsl);
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "cross_sell/frontend/availability/view",
          datacsl,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          Swal.close();

 let datasent = JSON.parse(response.request.response);
          let user_exists = datasent.user_exists;
			if (user_exists == "Y") {
			encryptStorage.setItem("crosssell_shown", "Yes");
			encryptStorage.setItem("crosssell_data", datasent);
			console.log("crosssell_data", datasent);
			encryptStorage.setItem("curr_search_results", this.searchres);
			console.log("datasent.data.length", datasent.data.length);
      let adhoc_count_cross = 0;
            let normal_count_cross = 0;
            for (let z = 0; z < datasent.data.length; z++) {
              console.log("suggestion_type", datasent.data[z].suggestion_type);
              console.log("status", datasent.data[z].status);
              if (
                datasent.data[z].suggestion_type == "A" &&
                datasent.data[z].status == "success"
              ) {
                adhoc_count_cross++;
              }
              if (
                datasent.data[z].suggestion_type == "R" &&
                datasent.data[z].status == "success"
              ) {
                normal_count_cross++;
              }
            }
            console.log("adhoc_count_cross", adhoc_count_cross);
            if (adhoc_count_cross == 0) {
              if (normal_count_cross > 0) {
                this.gotoPage("/crosssell.html");
              } else {
                this.gotoPage("/yourdetails.html");
              }
            } else {
              this.gotoPage("/crossselladhoc.html");
            }
          } else {
            encryptStorage.setItem("crosssell_shown", "No");
            this.gotoPage("/yourdetails.html");
          }
        });
      //}
    },
    genuuid() {
      if (sessionStorage.getItem("uuid") === null) {
        let uuidgen = uuidv4();
        this.setLocalData("uuid", uuidgen);
        return uuidgen;
      } else {
        return sessionStorage.getItem("uuid").replaceAll('"', "");
      }
    },
    checkproductincart(carpark_id) {
      if (this.cartdetails === carpark_id) {
        return true;
      } else {
        return false;
      }
    },
    resetpromocode() {
      let order_ref = encryptStorage.getItem("order_ref");
      let discount_coupon_applied = encryptStorage.getItem(
        "discount_coupon_applied"
      );
      if (typeof discount_coupon_applied !== "undefined") {
        let cartdata = {
          brand_id: this.setbrandid,
          booking_ref_id: order_ref,
          uuid: this.genuuid(),
          promo_code: discount_coupon_applied,
        };
        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
              "discount/frontend/promo_code/cancel",
            cartdata,
            {
              headers: {
                secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_RPROMO_SECRETID,
                secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_RPROMO_SECRETKEY,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response);
          });
      }
    },
    resetcart() {
      this.cancelling_selection = true;
      this.resetpromocode();
      setTimeout(function () {
        sessionStorage.removeItem("cart");
        encryptStorage.removeItem("session_pay"); 
        encryptStorage.removeItem("dis_cpk");
        encryptStorage.removeItem("dis_ftt");
        encryptStorage.removeItem("discount_amount");
        encryptStorage.removeItem("discount_amount_applied");
        encryptStorage.removeItem("discount_coupon_applied");
        window.location.reload();
      }, 3000);
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;
            if (
              response.data.slug == "HER" ||
              response.data.slug == "NOC" ||
              response.data.slug == "SZG"
            ) {
              this.currency = "€";
            }
          }
        });
    },
    async get_rez_data_k()
    {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") 
      {
        let _this = this;
        await axios.get('https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php')
        .then(response => {

        const key = 'XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn';
        const encryptedData = response.data;
        let dec = _this.decrypt_custom(key, encryptedData);
        
        encryptStorage.setItem("rez_dev_k",dec);
        
             
        })
        .then(() => {
          _this.getbranded();
        }
        )
        .catch(error => {
        console.error(error);
        });
        }
        else
        {
          this.getbranded();
        }
    },
    decrypt_custom(key, data) {
      
      const decodedData = Buffer.from(data, 'base64').toString('utf8');
        const parts = decodedData.split('::');
    
        // Extract IV
        key = Buffer.from(parts[0]);
        let iv = Buffer.from(parts[2], 'hex');
    
        // Extract encrypted data
        const encryptedData = Buffer.from(parts[1], 'base64');
    
        // Create decipher object with correct IV and key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    
        // Update decryption with encrypted data
        let decrypted = decipher.update(encryptedData);
    
        // Finalize the decryption
        decrypted = Buffer.concat([decrypted, decipher.final()]);
    
        return decrypted.toString('utf8');
} 
  },
  mounted() {
    this.get_rez_data_k();
    const urlParams = new URLSearchParams(window.location.search);

    let srchres=[];
    let cpl={};
    let cpkdetails=[];
    
    for (const key in this.searchres) {
      let res_items = this.searchres[key];
      let cpkitem_id = res_items.carpark_id;
      let pritem_id = res_items.product_id;
      res_items.cpk_pro=cpkitem_id+"_"+pritem_id;
      srchres.push(res_items);
      if(this.parkingproductdetails.clients[pritem_id])
      {
        
        let n = this.parkingproductdetails.clients[pritem_id];
        console.log('show_in_frontend',n);
        let show_in_frontend = n.show_in_frontend;
        console.log('show_in_frontend',show_in_frontend);
        if(show_in_frontend=="true")
        {
          let b = this.parkingproductdetails.clients[pritem_id];
          b.carpark_id = cpkitem_id;
          
          cpkdetails[cpkitem_id+"_"+pritem_id] = this.parkingproductdetails.clients[pritem_id];
          
        }
        else
        {
          let c = this.carparkdetails.clients[cpkitem_id];
          
          cpkdetails[cpkitem_id+"_"+pritem_id] =c;
        }
      }
      else
      {
        let c = this.carparkdetails.clients[cpkitem_id];
        
        cpkdetails[cpkitem_id+"_"+pritem_id] =c;
        
      }
    }
    this.srchres=srchres;
    cpl.clients = cpkdetails;
    this.cpkdetails=cpl;
    console.log('this.cpkdetails',this.cpkdetails);
    this.venue_select = urlParams.get("venue_select");
    this.venue_select_name = urlParams.get("venue_select_name");
    encryptStorage.setItem('venue_select_name_original_product',this.venue_select_name);    
    if (encryptStorage.getItem("cart") === undefined) {
      this.cartdetails = 0;
      this.chkcart = 0;
    } else {
      let crt = encryptStorage.getItem("cart");
      this.cartdetails = crt.product_id;
      this.chkcart = 1;
    }
  },
  updated() {},
};
</script>

<style lang="scss">
.swal2-popup.swal2-popup {
  width: auto;
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";
.result {
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #dfdfdf;
  margin-bottom: 1rem;

  &__view-more--hide {
    display: none;
  }

  &__column {
    &-right {
      width: 40%;
    }

    &-left {
      width: 60%;
    }
  }

  &__row {
    &-01 {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media screen and (max-width: 1024px) {
        align-items: flex-start;
      }
    }

    &-02 {
      padding: 1rem 0;
      height: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #dfdfdf;
    }
  }

  &__parking {
    &-icon {
      width: 100%;
      img {
        width: 100%;
        height: auto;
      }

      &.color-01 {
        //background-color: #3bbdd1;
      }

      &.color-02 {
        background-color: #3bbdd1;
      }

      &.color-03 {
        background-color: #0a3b74;
      }

      &.color-04 {
        background-color: #a8a8a8;
      }
    }
    &-data {
      padding-left: 1.875rem;
      padding-top: 23px;

      ul {
        columns: 2;
        padding: 0;

        @media screen and (max-width: 1024px) {
          columns: 1;
        }

        li {
          padding: 0;
          margin: 0;
          list-style-position: inside;
          line-height: 1.4;
          color: #707070;
          font-size: 0.875rem;
        }
      }
    }
    &-rating {
      padding-left: 0.875rem;
      &-reviews {
        font-size: 0.875rem;
      }
    }
    &-type {
      padding-right: 1.5rem;
      font-family: var(--result_tagline_font_family, inherit);
      font-size: var(--result_tagline_font_size, 1rem);
      font-weight: var(--result_tagline_font_weight, 700);
      color: var(--result_tagline_font_color, #0a3b74);
      text-align: center;
    }
  }

  &__headline {
    font-family: var(--result_title_font_family, inherit);
    font-size: var(--result_title_font_size, 16px);
    font-weight: var(--result_title_font_weight, 700);
    color: var(--result_title_font_color, #0a3b74);
  }

  &__right-row {
    &-01 {
      height: 50%;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &-02 {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50%;
    }
  }

  &__info,
  &__map {
    color: #0a3b74;
    font-size: 1.5rem;
    width: 100%;
    max-width: 6rem;
    height: 100%;
    text-align: center;
    border-right: 1px solid #dfdfdf;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    cursor: pointer;
    @media screen and (min-width: 992px) {
      max-width: 10rem;
    }
  }

  &__info-image,
  &__map-image {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }

  &__button {
    flex: 1;
    padding-right: 0.5rem;

    button {
      width: 100%;
      background-color: var(--result_button_primary_background, #034a94);
      color: var(--result_button_primary_font_color, #ffffff);
      border-radius: var(--result_button_primary_border_radius, 8px);
      box-shadow: 0px 3px 6px #00000029;
      padding: 1.5rem;
      border: none;
    }
    button:disabled {
      filter: saturate(0);
      cursor: not-allowed;
    }
  }

  &__distance {
    border-right: 1px solid #dfdfdf;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;
    font-size: 12px;

    // enable once ready
    .result__info-transfer {
      background: var(--result_time_dist_transfer_background, #0a3b74);
      color: var(--result_time_dist_transfer_font_color, #fff);
      padding: 0.2rem 0.6rem;
      border-radius: 1rem;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: auto;
        height: 16px;
        margin-right: 0.25rem;
      }
    }
  }

  &__info-time {
    //color: #034a94;
    span {
      font-family: var(--result_time_dist_font_family, inherit);
      font-size: var(--result_time_dist_font_size, 1.2rem);
      font-weight: var(--result_time_dist_font_weight, 600);
      color: var(--result_time_dist_font_color, #0a3b74);
    }
  }

  &__cost {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;
    font-size: 12px;
  }

  margin-left: 15px;
  margin-right: 15px;
  box-sizing: border-box;
  width: auto;

  &-grid {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  &__headline {
    text-align: center;
    font-size: 1.2rem;
    margin: 0;
    padding: 1rem;
    border-bottom: 1px solid #dfdfdf;
  }

  &__column {
    &-left,
    &-right {
      width: 100%;
    }

    &-left {
      .result__row-01 {
        flex-direction: column;
      }
    }
  }

  &__parking {
    &-icon {
      width: 100%;
    }
  }

  &__right-row-01 {
    padding: 0;
    border-bottom: 1px solid #dfdfdf;
    margin: 0;
    margin-bottom: 0.5rem;
  }

  &__distance,
  &__cost {
    padding: 1rem 0;
  }

  &__distance {
    border: none;
    border-right: 1px solid #dfdfdf;
  }

  &__info-cost {
    font-family: var(--result_price_font_family, inherit);
    font-size: var(--result_price_font_size, 1.5rem);
    font-weight: var(--result_price_font_weight, bold);
    color: var(--result_price_font_color, #0a3b74);
  }

  &__info-cost-total_amount {
    text-decoration: line-through;
    margin-left: 0.5rem;
    font-family: var(--result_price_subtext_font_family, inherit);
    font-size: var(--result_price_subtext_font_size, 0.9rem);
    font-weight: var(--result_price_subtext_font_weight, bold);
    color: var(--result_price_subtext_font_color, #7a8390);
  }

  &__info-text {
    font-family: var(--result_time_dist_subtext_font_family, inherit);
    font-size: var(--result_time_dist_subtext_font_size, 0.825rem);
    font-weight: var(--result_time_dist_subtext_font_weight, bold);
    color: var(--result_time_dist_subtext_font_color, #0a3b74);
  }

  &__map-desktop,
  &__info-desktop {
    //color: #236ca3;
    font-family: var(--result_button_secondary_font_family, inherit);
    font-weight: var(--result_button_secondary_font_weight, normal);
    color: var(--result_button_secondary_font_color, #0a3b74);
    background: var(--result_button_secondary_background, #e9e7e7);
    border: var(--result_button_secondary_border, none);
    border-radius: var(--result_button_secondary_border_radius, 4px);
  }

  &__buttons,
  &__data {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  &__buttons {
    padding-bottom: 0.5rem;

    div:first-child {
      margin-left: 0.5rem;
    }

    button {
      width: 100%;
      background-color: var(--result_button_primary_background, #034a94);
      color: var(--result_button_primary_font_color, #ffffff);
      border-radius: var(--result_button_primary_border_radius, 8px);
      box-shadow: 0px 3px 6px #00000029;
      border: none;
      padding: 1rem;
      font-size: 1rem;
      font-weight: bold;
    }
  }

  &__button-secondary button {
    // background-color: #e9e7e7;
    // color: #0a3b74;
    font-family: var(--result_button_secondary_font_family, inherit);
    font-weight: var(--result_button_secondary_font_weight, normal);
    color: var(--result_button_secondary_font_color, #0a3b74);
    background: var(--result_button_secondary_background, #e9e7e7);
    border: var(--result_button_secondary_border, none);
    border-radius: var(--result_button_secondary_border_radius, 4px);
  }

  &__details {
    padding: 0.5rem;
    margin: 0;
    margin-bottom: 0.5rem;
    border-top: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
    text-align: center;
    li {
      list-style-position: inside;
      // list-style: none;
      width: auto;
    }

    &--list {
      display: var(--details_as_list, block);
      font-size: 1rem;
      margin: 0.3rem auto;
      color: #707070;
      width: 100%;
    }

    &--paragraph {
      display: var(--details_as_paragraph, block);
      font-size: 1rem;
      margin: 0.3rem auto;
      padding: 1rem;
      color: #707070;
    }
  }
}

.map-render--pdf {
  // min-width: 300px;
  min-height: 300px;
  height: 80vh;
  width: 100%;
  position: relative;
  display: flex;
  iframe {
    width: 1000px;
  }
}

.map-render--img {
  // min-width: 300px;
  max-width: 900px;
  height: auto;
  position: relative;
  display: flex;
  img {
    width: 100%;
  }
}

.result-disabled {
  // display: none;
  filter: saturate(0);
  .result__info-cost {
    color: #999;
  }
}

.fas.fa-chevron-down {
  font-size: 0.75em;
}

.list-more-info-button {
  margin-left: 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.result__buttons-secondary {
  display: flex;
  gap: 0rem;
  // padding: 0.5rem 1rem 1rem;
  .result__button-secondary {
    padding: 0;

    svg {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.3s normal forwards ease-in-out;
  -webkit-animation: fadeIn 0.3s normal forwards ease-in-out;
  -moz-animation: fadeIn 0.3s normal forwards ease-in-out;
  -o-animation: fadeIn 0.3s normal forwards ease-in-out;
  -ms-animation: fadeIn 0.3s normal forwards ease-in-out;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.upsell-header {
  text-align: left;
  font-family: var(--result_title_font_family, inherit);
  font-size: var(--result_title_font_size, 1rem);
  font-weight: var(--result_title_font_weight, 700);
  color: var(--result_title_font_color, #0a3b74);
}
.upsell-model {
  max-width: 500px;
  &__closer-from {
    padding: 1rem 1rem;
    text-align: center;
    font-size: 2rem;
    font-family: var(--upsell_popup_font_family, inherit);
    font-weight: var(--upsell_popup_font_weight, 700);
    color: var(--upsell_popup_font_color, #0a3b74);
    background: var(--upsell_popup_background, #f6f6f6);
  }
  &__carpark-name {
    text-align: center;
    padding: 0.5rem 1rem;
    font-weight: bold;
  }
  &__cost {
    h3 {
      font-family: var(--result_price_font_family, inherit);
      font-size: var(--result_price_font_size, 1.5rem);
      font-weight: var(--result_price_font_weight, bold);
      color: var(--result_price_font_color, #0a3b74);
    }
  }
  &__buttons {
    border-top: 1px solid #e6e6e6;
    padding: 1rem 1rem 0;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
    gap: 1rem;
    button {
      border-radius: 0;
      padding: 1rem;
      flex: auto 1;
      &.upsell-model__buttons-no {
        font-family: var(--result_button_secondary_font_family, inherit);
        font-weight: var(--result_button_secondary_font_weight, bold);
        color: var(--result_button_secondary_font_color, #0a3b74);
        background: var(--result_button_secondary_background, #e9e7e7);
        border: var(--result_button_secondary_border, none);
        border-radius: var(--result_button_secondary_border_radius, 4px);
        width: 100%;
      }
      &.upsell-model__buttons-yes {
        font-family: var(--result_button_secondary_font_family, inherit);
        font-weight: var(--result_button_secondary_font_weight, bold);
        background-color: var(--result_button_primary_background, #034a94);
        color: var(--result_button_primary_font_color, #ffffff);
        border: var(--result_button_secondary_border, none);
        border-radius: var(--result_button_secondary_border_radius, 4px);
        width: 100%;
      }
    }
  }
  &__distance-price {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row;
    width: 100%;
    div {
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: center;
      padding: 1rem 1rem;
      border-right: 1px solid #e6e6e6;
      &:last-child {
        border-right: none;
      }
    }
    .result__info-transfer {
      width: auto;
      display: inline-block;
      background: var(--result_time_dist_transfer_background, #0a3b74);
      color: var(--result_time_dist_transfer_font_color, #fff);
      padding: 0.2rem 0.6rem;
      border-radius: 1rem;
      font-size: 12px;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      img {
        width: auto;
        height: 16px;
        margin-right: 0.25rem;
      }
    }
  }
  .result__parking-data {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 1rem 0;
    ul {
      columns: initial;
      border-top: 0px solid #dfdfdf;
      border-bottom: 0px solid #dfdfdf;
      text-align: center;
      li {
        list-style-position: inside;
        margin: 0.5rem;
      }
    }
  }
}
</style>
